export default __webpack_public_path__ + "static/media/charts-icon.3dcb3bc4.svg";